const DEFAULT_ENABLED_ODS_FOR_SEARCH = {
    enableExternalUser: false,
    enableInternalUser: false,
    isfUserIds: [],
};

export const normalizeEnabledOdsForSearch = (flagValue) => {
    if (!flagValue || typeof flagValue !== "object") {
        return DEFAULT_ENABLED_ODS_FOR_SEARCH;
    }

    return {
        enableExternalUser: Boolean(flagValue.enableExternalUser),
        enableInternalUser: Boolean(flagValue.enableInternalUser),
        isfUserIds: Array.isArray(flagValue.isfUserIds)
            ? flagValue.isfUserIds
                  .map((userId) => userId)
                  .filter(Boolean)
            : [],
    };
};

export const getUserTypeFromDetails = (userDetails) => {
    const isInternalUser  = userDetails?.isUserInternal;

    return isInternalUser ? "internal" : "external";
};

const normalizeUserId = (userId) => {
    return String(userId ?? "").trim().toLowerCase();
};

export const evaluateOdsAccess = (flagValue, userDetails = null) => {
    const { enableExternalUser, enableInternalUser, isfUserIds } =
        normalizeEnabledOdsForSearch(flagValue);

    const directMode = enableInternalUser && enableExternalUser;
    if (directMode) {
        return {
            shouldCallMuleSoft: false,
            shouldCallODS: true,
        };
    }

    if (!userDetails) {
        return {
            shouldCallMuleSoft: true,
            shouldCallODS: false,
        };
    }

    const normalizedUserId = normalizeUserId(userDetails?.userId);
    const isfUserIdMatched =
        normalizedUserId !== "" &&
        isfUserIds.some(
            (flagUserId) => normalizeUserId(flagUserId) === normalizedUserId
        );

    const userType = getUserTypeFromDetails(userDetails);
    const isInternalUser = userType === "internal";
    const isExternalUser = userType === "external";
    const isUserTypeAllowed =
        (enableInternalUser && isInternalUser) ||
        (enableExternalUser && isExternalUser);

    return {
        shouldCallMuleSoft: true,
        // User type and explicit ISF user IDs are additive ODS allow rules.
        shouldCallODS: isUserTypeAllowed || isfUserIdMatched,
    };
};
